export type MessageId = {
  readonly brand: "message_id";
  readonly value: string;
};

export function messageId(value: string): MessageId {
  return { brand: "message_id", value };
}
